export default {
    namespaced: true,
    state: {
        datafiles: ['games', 'events'],
        newsList: [],
        currNews: {},
        sourceTargetKey: './data/',
        downloadKeys: ['introduce', 'source', 'psd', 'special']
    },
    mutations: {
        SET_NEWSLIST(state, options) {
            state.newsList = options;
        },
        SET_CURRNEWS(state, options) {
            state.currNews = options;
        }
    },
    actions: {
        getNews({ state, commit }) {
            const urls = [];
            for (const i in state.datafiles) {
                const file = state.datafiles[i];
                const link = state.sourceTargetKey + file + '.json';
                urls.push(link);
            }
            const doSth = async () => {
                const results = await Promise.all(urls.map(url => fetch(url).then(response => response.json())));
                const newArr = [];
                for (const i in results) {
                    const curr = results[i];
                    newArr.push(...curr);
                }
                newArr.sort((a, b) => {
                    return a.date_start > b.date_start ? 1 : -1;
                });
                commit('SET_NEWSLIST', newArr);
            };
            doSth();
        },
        setCurrNews(context, options) {
            context.commit('SET_CURRNEWS', options);
        }
    }
};
